import PdfButton from './PdfButton'
import pdfButtonContainer from './pdfButtonContainer'

export default pdfButtonContainer(PdfButton)
